const shouldHideFeature = (feature) => feature !== 'true' || !feature;
export const isLaborAvailabilityCalendarEnabled = !shouldHideFeature(process.env.REACT_APP_FEATURE_LABOR_AVAILABILITY_CALENDAR);
